const UNIT_CATEGORIES = {
  CFU: ['CPU', 'CDC', 'DCWH', 'DC', 'landbank', 'LDC', 'RWHCDC'],
  CMP: [
    'CSC',
    'homeServicePoint',
    'ikeaMiniPlanAndOrderPoint',
    'ikeaPickUpPointBranded',
    'ikeaPickUpPointUnbranded',
    'ikeaPlanAndOrderPoint',
    'ikeaPlanAndOrderPointS',
    'ikeaPlanAndOrderPointXS',
    'ikeaPopUp',
    'IKEA Small Store (S)',
    'IKEA Small Store (L)',
    'IKEA Small Store (M)',
    'ikeaSmallStoreLadaS',
    'ikeaSmallStoreLadaM',
    'ikeaStore',
    'landbank',
  ],
  meetingPlace: ['centresMeetingPlace'],
  office: [
    'digitalHub',
    'landbank',
    'serviceOffice',
    'Business Support Unit',
    'Distribution Support Unit',
  ],
  other: ['explorationCase', 'EMPU', 'noneCoreAsset', 'RWHCMP'],
  LADA: ['ikeaSmallStoreLadaM', 'ikeaSmallStoreLadaS'],
};

export const getUnitsByCategory = (
  category,
  unitNames,
  establishmentType?: string,
) => {
  let finalCategory = category;
  if (establishmentType === 'LADA') {
    finalCategory = 'LADA';
  }
  if (!UNIT_CATEGORIES[finalCategory]) {
    return [];
  }

  const object = {};

  UNIT_CATEGORIES[finalCategory].forEach((unitKey) => {
    object[unitKey] = unitNames[unitKey] || unitKey;
  });
  return object;
};

export const isUnitTypeLada = (unitType) => {
  return UNIT_CATEGORIES.LADA.includes(unitType);
};
